
import Vue, { PropType } from 'vue';
import { PipelineNotificationType } from '../typings/PipelineNotificationType';
import BellNotification from './BellNotification.vue';
export default Vue.extend({
  name: 'BellNotificationMonitor',
  components: {
    BellNotification,
  },
  props: {
    notifications: {
      type: [] as PropType<PipelineNotificationType[]>,
    },
  },
  computed: {
    pipeline(): PipelineNotificationType[] {
      return this.notifications;
    },
  },
});
